/* YAMU: explain the disabled checkout button.
   The Terms and Conditions app disables checkout until its checkbox is ticked,
   and a disabled button gives no feedback at all. CSS sets pointer-events:none
   on disabled checkout buttons so the click reaches the document; this catches
   it, and when the click landed on a disabled checkout button with the terms
   box unticked, it shows a message and shakes the checkbox. Works on the cart
   drawer and the /cart page alike, and survives drawer innerHTML re-renders
   because the listener lives on the document. */
(function () {
  'use strict';

  var MSG = 'Please tick the box above to accept the Return Policy and Terms and Conditions before checking out.';

  function nudge(btn) {
    var scope = btn.closest('.cart-drawer__footer, .cart__footer, .drawer__footer, form') || document;
    var box = scope.querySelector('.tos-app-extension') || document.querySelector('.tos-app-extension');
    if (!box) return;
    var cb = box.querySelector('input[type="checkbox"]');
    if (cb && cb.checked) return; /* disabled for some other reason */

    var msg = box.querySelector('.yamu-terms-nudge');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'yamu-terms-nudge';
      msg.setAttribute('role', 'alert');
      msg.textContent = MSG;
      box.appendChild(msg);
    }
    if (cb && !cb.dataset.yamuNudgeBound) {
      cb.dataset.yamuNudgeBound = 'true';
      cb.addEventListener('change', function () {
        if (cb.checked) {
          var m = box.querySelector('.yamu-terms-nudge');
          if (m) m.remove();
          box.classList.remove('yamu-terms-nudge--on');
        }
      });
    }
    box.classList.remove('yamu-terms-nudge--on');
    void box.offsetWidth; /* restart the shake animation */
    box.classList.add('yamu-terms-nudge--on');
    if (box.scrollIntoView) box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  /* Instant enable.
     The Terms app enables the checkout button only AFTER a round-trip to
     /cart/update.js (it writes a tos_accepted cart attribute first, and its
     toggle helper refuses to enable while that request is in flight). On a
     slow connection that is seconds of a dead button after ticking the box.
     This listener runs in the bubble phase, after the app's own handler on
     the input, and flips the button immediately. The app's request still
     completes in the background, so the compliance record is unchanged, and
     its final sync lands on the same state. */
  function setCheckout(cb, on) {
    var scope = cb.closest('.cart-drawer__footer, .cart__footer, .drawer__footer, form') || document;
    var btns = scope.querySelectorAll('button[name="checkout"]');
    if (!btns.length) btns = document.querySelectorAll('button[name="checkout"]');
    Array.prototype.forEach.call(btns, function (b) {
      if (on) {
        b.removeAttribute('disabled');
        b.classList.remove('disabled');
        b.style.pointerEvents = 'auto';
        b.style.opacity = '1';
        b.style.cursor = '';
      } else {
        b.setAttribute('disabled', 'disabled');
        b.classList.add('disabled');
      }
    });
  }

  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || !cb.matches || !cb.matches('.tos-app-extension input[type="checkbox"]')) return;
    setCheckout(cb, cb.checked);
    /* the app re-disables synchronously inside its own handler when its save
       flag is up; run once more on the next tick so ours is the final word
       until its request completes */
    setTimeout(function () { setCheckout(cb, cb.checked); }, 0);
  });

  /* Keep it enabled.
     The app re-disables the checkout button through several paths after the
     box is ticked: its own save routine (a flag stays up during a cart
     round-trip), a DOM observer that re-inits on ANY insertion (its own hidden
     inputs trigger it), and the footer re-render. Chasing each path by timing
     is fragile. Instead: while the shopper has the box ticked on this page,
     watch the button's disabled attribute and reverse any re-disable at once.
     The app only reacts to child insertions, not attribute changes, so this
     cannot loop. Unticking the box hands control straight back to the app. */
  var accepted = false;

  function enforce() {
    if (!accepted) return;
    var btns = document.querySelectorAll('button[name="checkout"]');
    Array.prototype.forEach.call(btns, function (b) {
      if (b.hasAttribute('disabled') || b.classList.contains('disabled') ||
          b.style.pointerEvents === 'none' || (b.style.opacity && b.style.opacity !== '1')) {
        b.removeAttribute('disabled');
        b.classList.remove('disabled');
        b.style.pointerEvents = 'auto';
        b.style.opacity = '1';
        b.style.cursor = '';
      }
    });
    var boxes = document.querySelectorAll('.tos-app-extension input[type="checkbox"]');
    Array.prototype.forEach.call(boxes, function (cb) { if (!cb.checked) cb.checked = true; });
  }

  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || !cb.matches || !cb.matches('.tos-app-extension input[type="checkbox"]')) return;
    accepted = cb.checked;
    if (accepted) {
      enforce();
      /* the app's re-inits land on the next frame and after its request */
      [0, 30, 100, 250, 600, 1200, 2500].forEach(function (ms) { setTimeout(enforce, ms); });
    }
  });

  /* attribute watcher: the definitive guard */
  var mo = new MutationObserver(function (muts) {
    if (!accepted) return;
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (muts[i].type === 'attributes') {
        if (t && t.matches && t.matches('button[name="checkout"]')) { enforce(); return; }
      } else if (muts[i].addedNodes && muts[i].addedNodes.length) {
        requestAnimationFrame(function () { setTimeout(enforce, 0); });
        return;
      }
    }
  });
  mo.observe(document.documentElement, {
    childList: true, subtree: true,
    attributes: true, attributeFilter: ['disabled', 'class', 'style']
  });

  document.addEventListener('click', function (e) {
    var btns = document.querySelectorAll('button[name="checkout"][disabled]');
    if (!btns.length) return;
    for (var i = 0; i < btns.length; i++) {
      var r = btns[i].getBoundingClientRect();
      if (!r.width) continue;
      if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
        e.preventDefault();
        nudge(btns[i]);
        return;
      }
    }
  }, true);
})();
